// @ts-expect-error not typed
import AsyncSaveAsTemplateModal from 'EmailComponents/modals/actionModals/AsyncSaveAsTemplateModal';
// @ts-expect-error not typed
import AsyncSaveTemplateUpgradeModal from 'EmailComponents/modals/upgrade/AsyncSaveTemplateUpgradeModal';
// @ts-expect-error not typed

import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import EmailCloneContainer from 'email-management-lib/EmailClone/components/EmailCloneContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const RenderActionModal = ({
  selectedModal,
  selectedEmail,
  crmObject,
  onModalClose,
  openModal
}) => {
  switch (selectedModal) {
    case 'cloneOrConvertEmail':
      return /*#__PURE__*/_jsx(EmailCloneContainer, {
        email: selectedEmail,
        crmObject: crmObject,
        onClose: onModalClose
      });
    case 'saveAsTemplate':
      return /*#__PURE__*/_jsx(AsyncSaveAsTemplateModal, {
        email: selectedEmail,
        emailId: selectedEmail.id,
        onClone: email => openModal('cloneOrConvertEmail', email),
        onClose: onModalClose,
        onSave: () => {
          trackDashboardInteraction({
            otherActions: 'save-as-template',
            screen: 'manage'
          });
        },
        showCTAButton: true
      });
    case 'lockedSaveAsTemplate':
      return /*#__PURE__*/_jsx(AsyncSaveTemplateUpgradeModal, {});
    default:
      return null;
  }
};
export default RenderActionModal;